import 'react-placeholder/lib/reactPlaceholder.css';

import './debug';
import './style/reset.css';
import './style/index.css';

import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
